import React, { useEffect, useState, useCallback, useRef } from "react";
import Cookies from "js-cookie";
import { Modal, Button } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { NavLink } from "react-router-dom";
import { MdRestore } from "react-icons/md";
import { IoPersonRemoveSharp } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { deleteUser } from "../../../Redux/userSlice";
import { restoreUser } from "../../../Redux/userSlice";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import "./Staff.css";

export default function Staff() {
  const [show, setShow] = useState(false);
  const [fullscreen, setFullscreen] = useState(true);
  const [staffList, setStaffList] = useState([]);
  const [gridApi, setGridApi] = useState("");
  const gridRef = useRef();
  const dispatch = useDispatch();
  const handleShow = () => {
    setShow(true);
    setFullscreen(true);
  };

  const handleDelete = (id) => {
    dispatch(deleteUser({ id }));
  };
  const handleRestore = (id) => {
    dispatch(restoreUser({ id }));
  };

  const token = localStorage.getItem("token");

  // Trans Table - start\

  const columnDefs = [
    {
      headerName: "Full Name",
      field: "name",
      width: 250,
    },
    {
      headerName: "Phone Number",
      field: "phoneNumber",
      width: 250,
    },
    {
      headerName: "Role",
      field: "role",
      width: 250,
    },
    {
      headerName: "Store Name",
      field: "store.name",
      width: 250,
    },
    {
      headerName: "Store Address",
      field: "store.address",
      width: 250,
    },
    {
      headerName: "Action",
      field: "id",
      width: 300,
      cellRenderer: ({ data }) => {
        return (
          <div className="d-grid py-1">
            {data.destroyTime !== null ? (
              <button
                className="btn btn-warning btn-sm"
                onClick={() => {
                  handleRestore(data.id);
                }}
              >
                <MdRestore />
                Restore
              </button>
            ) : (
              <button
                className="btn btn-danger btn-sm"
                onClick={() => {
                  handleDelete(data.id);
                }}
              >
                <IoPersonRemoveSharp /> Delete
              </button>
            )}
          </div>
        );
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    filter: true,
    floatingFilter: true,
  };

  // const onGridReady = useCallback((params) => {
  //   params.api.sizeColumnsToFit();
  //   setGridApi(params);
  //   fetch("https://hook.eu1.make.com/xwa6yi6jzfe5c18j2a3o8xrsciyyuj91", {
  //     token: token,
  //   })
  //     .then((res) => res.json())
  //     .then((res) => {
  //       params.api.applyTransaction({ add: res.data.staffs.rows });
  //     });
  // }, []);
  const onGridReady = useCallback((params) => {
    params.api.sizeColumnsToFit();
    setGridApi(params);
    axios
      .post(
        "https://hook.eu1.make.com/xwa6yi6jzfe5c18j2a3o8xrsciyyuj91",{token},
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        if(res.data.statusCode === 401){
          Cookies.remove("phone_number");
          Cookies.remove("national_id");
          localStorage.clear();
          window.location.reload();
        }
        else{
          params.api.applyTransaction({ add: res.data.data.staffs.rows });
        }
      });
  }, []);

  const onExportClick = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);

  // Trans Table - end

  const { t } = useTranslation();

  return (
    <div className="staff d-grid">
      <Button
        variant="light"
        type="submit"
        className="account-btn py-3"
        size="lg"
        onClick={handleShow}
      >
        {t("viewCashiers")}
      </Button>
      <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title> {t("viewCashiers")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="filter-parent py-1 mb-2">
            <Button variant="warning" size="sm" className="px-4 my-2 mx-2">
              <NavLink to="/register" className="add-user-btn">
                {t("addNewUser")}
              </NavLink>
            </Button>
            <Button
              variant="success"
              size="sm"
              className="px-4 my-2 mx-2"
              onClick={onExportClick}
            >
              Export to Excel
            </Button>
          </div>

          <div className="ag-theme-alpine trans-table">
            <AgGridReact
              ref={gridRef}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              onGridReady={onGridReady}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
